import React from "react";
import { FormattedMessage } from "react-intl";
import config from "../../config";
import { Message } from "../../interfaces";
interface DropdownProps {
  x: number;
  y: number;
  visible: boolean;
}

import {
  IconFlagFilled,
  IconArrowBackUp,
  IconCopy,
  IconMicroscope,
  IconMenu,
} from "@tabler/icons-react";

const isDev = config.ENV === "staging" || config.ENV === "local";

export interface ActionDropdownProps {
  selectedMessage: Message | null;
  dropdown: DropdownProps;
  onClose: () => void;
  onAction: ({ action }: { action: string }) => void;
  actions: string[];
}

const getIcon = (action: string) => {
  switch (action) {
    case "reply":
      return <IconArrowBackUp size={14} />;
    case "clone":
      return <IconCopy size={14} />;
    case "flag":
      return <IconFlagFilled size={14} />;
    case "debug":
      return <IconMicroscope size={14} />;
    default:
      return <IconMenu size={14} />;
  }
};
const ActionItem: React.FC<{
  action: string;
  onClick: () => void;
}> = ({ action, onClick }) => (
  <div className="chat-item-options-action-item" onClick={onClick}>
    <div className="flex gap-2 flex-row align-items-center">
      {getIcon(action)}
      <FormattedMessage
        id={`chats.${action}`}
        defaultMessage={action.charAt(0).toUpperCase() + action.slice(1)}
      />
    </div>
  </div>
);

const ActionDropdown = React.forwardRef<HTMLDivElement, ActionDropdownProps>(
  ({ dropdown, onClose, onAction, actions, selectedMessage }, ref) => {
    const { x, y, visible } = dropdown;
    if (!visible) return null;

    return (
      <div
        className="chat-item-options-actions"
        ref={ref}
        style={{
          position: "fixed",
          top: y,
          left: x,
        }}
      >
        {actions
          .filter((a) => ["reply"].includes(a))
          .map((action) => (
            <ActionItem
              key={action}
              action={action}
              onClick={() => {
                onAction({ action });
                onClose();
              }}
            />
          ))}

        {selectedMessage?.right && (
          <>
            <hr className="chat-item-options-action-item-divider" />
            {actions
              .filter(
                (a) =>
                  !["reply", "clone", "debug"].includes(a) || // incluir todo excepto estos dos
                  (["clone", "debug"].includes(a) && isDev) // incluir clone/debug solo si isDev
              )
              .map((action) => (
                <ActionItem
                  key={action}
                  action={action}
                  onClick={() => {
                    onAction({ action });
                    onClose();
                  }}
                />
              ))}
          </>
        )}
      </div>
    );
  }
);

export default ActionDropdown;
